<template>
  <v-card
    :key="nodeDataLocale.id"
    class="pt-6"
    flat
  >
    <v-form
      ref="formTreeRef"
      class="multi-col-validation"
      @submit.prevent="handleSubmit"
    >
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            sm="6"
          >
            <v-text-field
              v-model="nodeDataLocale.numero"
              label="Número da opção *"
              placeholder="Número da opção"
              outlined
              class="mt-2"
              type="number"
              min="0"
              validate-on-blur
              :rules="[(v) => !!v || 'Este campo é obrigatório', (v) => v >= 1 || 'A opção deve ser maior que zero']"
              @change="nodeConfig"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
          >
            <v-select
              v-model="nodeDataLocale.chatBotNoTipoId"
              :items="tiposDeNo"
              class="mt-2"
              item-text="nome"
              item-value="id"
              label="Tipo de nó *"
              outlined
              validate-on-blur
              :disabled="inativarSelecaoDeTipo"
              :rules="[validators.select]"
              @change="nodeConfig"
            />
          </v-col>
        </v-row>

        <!-- nao mostrar quando for do tipo botaoOpcao OU listaOpcao -->
        <v-textarea
          v-if="!isIdPaiTipoBotaoOuLista"
          v-model="nodeDataLocale.texto"
          label="Texto *"
          placeholder="Configure a seção"
          outlined
          auto-grow
          rows="1"
          row-height="15"
          class="mt-2"
          :rules="[validators.required]"
          @change="nodeConfig"
        ></v-textarea>

        <node-tipo-texto
          v-if="isNodeTipoTexto"
          @node-config="$emit('node-alterado')"
        />

        <node-tipo-fila
          v-if="isNodeTipoFila"
          @node-config="$emit('node-alterado')"
        />

        <node-tipo-voltar
          v-if="isNodeTipoVoltar"
          @node-config="$emit('node-alterado')"
        />

        <node-tipo-encerrar
          v-if="isNodeTipoEncerrar"
          @node-config="$emit('node-alterado')"
        />

        <node-tipo-arvore
          v-if="isNodeTipoArvore"
          :arvores="arvoresDisponiveis"
          @node-config="$emit('node-alterado')"
        />

        <node-tipo-botao
          v-if="isNodeTipoBotao"
          @node-config="$emit('node-alterado')"
        />

        <node-tipo-lista
          v-if="isNodeTipoLista"
          @node-config="$emit('node-alterado')"
        />

        <node-tipo-formulario
          v-if="isNodeTipoFormulario"
          @node-config="$emit('node-alterado')"
        />

        <node-tipo-chat-gpt
          v-if="isNodeTipoChatGPT"
          @node-config="$emit('node-alterado')"
        />

        <node-tipo-nota-pesquisa
          v-if="isNodeTipoNota"
        />

        <node-tipo-agendamento
          v-if="isNodeTipoAgendamento"
          @node-config="$emit('node-alterado')"
        />

        <node-tipo-api
          v-if="isNodeTipoAPI"
          @node-config="$emit('node-alterado')"
        />

        <span class="d-flex justify-end mt-1 text-caption">* CAMPOS OBRIGATÓRIOS</span>
      </v-card-text>

      <v-row
        class="d-flex justify-center"
        tag="v-card-text"
      >
        <v-btn
          outlined
          class="me-3 mt-3 mb-3"
          @click="$emit('cancelar-handle')"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="success"
          class="me-3 mt-3 mb-3"
          :loading="loading"
          type="submit"
        >
          Salvar
        </v-btn>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import Vue from 'vue'
import { computed, ref, watch, provide } from '@vue/composition-api'
import { required, select } from '@/@core/utils/validation'
import NodeTipoTexto from './tipo-texto/NodeTipoTexto.vue'
import NodeTipoFila from './tipo-fila/NodeTipoFila.vue'
import NodeTipoVoltar from './tipo-voltar/NodeTipoVoltar.vue'
import NodeTipoEncerrar from './tipo-encerrar/NodeTipoEncerrar.vue'
import NodeTipoArvore from './tipo-arvore/NodeTipoArvore.vue'
import NodeTipoBotao from './tipo-botao/NodeTipoBotao.vue'
import NodeTipoLista from './tipo-lista/NodeTipoLista.vue'
import NodeTipoFormulario from './tipo-formulario/NodeTipoFormulario.vue'
import NodeTipoChatGpt from './tipo-chatgpt/NodeTipoChatGpt.vue'
import NodeTipoNotaPesquisa from './tipo-nota-pesquisa/NodeTipoNotaPesquisa.vue'
import NodeTipoAgendamento from './tipo-agendamento/NodeTipoAgendamento.vue'
import NodeTipoApi from './tipo-api/NodeTipoApi.vue'
import NodeChatBotModel from '@/models/entities/chat-bot/NodeChatBotModel'
import TipoNoChatBotEnum from '@/models/entities/chat-bot/TipoNoChatBotEnum'
import ChatBotService from '@/services/modules/ChatBotService'

export default {
  components: {
    NodeTipoTexto,
    NodeTipoFila,
    NodeTipoVoltar,
    NodeTipoEncerrar,
    NodeTipoArvore,
    NodeTipoBotao,
    NodeTipoLista,
    NodeTipoFormulario,
    NodeTipoChatGpt,
    NodeTipoNotaPesquisa,
    NodeTipoAgendamento,
    NodeTipoApi,
  },

  props: {
    nodeSelecionado: {
      type: Object,
      default: () => {},
    },
    chatBotId: {
      type: Number,
      default: null,
      required: true,
    },
    arvoreId: {
      type: Number,
      default: null,
      required: true,
    },
    tipoIdPai: {
      type: Number,
      default: null,
    },
    isArvoreEscolhidaPesquisaSatisfacao: Boolean,
  },

  setup(props, { emit }) {
    const nodeDataLocale = ref(new NodeChatBotModel())

    const loading = ref(false)
    const arvoresDisponiveis = ref([])

    const isNodePaiDoTipoNotaPesquisa = computed(() => props.tipoIdPai === TipoNoChatBotEnum.NotaPesquisa.id)

    function getTiposDeNodes() {
      const tiposDeNodes = Object.values(TipoNoChatBotEnum)

      if (props.isArvoreEscolhidaPesquisaSatisfacao && isNodePaiDoTipoNotaPesquisa.value) {
        nodeDataLocale.value.chatBotNoTipoId = TipoNoChatBotEnum.NotaPesquisa.id

        return [TipoNoChatBotEnum.NotaPesquisa]
      }

      if (props.isArvoreEscolhidaPesquisaSatisfacao) {
        return tiposDeNodes
      }

      return tiposDeNodes.filter(it => it.id !== TipoNoChatBotEnum.NotaPesquisa.id)
    }
    const tiposDeNo = computed(getTiposDeNodes)

    watch(() => props.nodeSelecionado, value => {
      nodeDataLocale.value = value
    }, { immediate: true, deep: true })

    provide('nodeData', nodeDataLocale)

    const tipoIdPai = ref(0)

    watch(() => props.tipoIdPai, value => {
      tipoIdPai.value = value
    }, { immediate: true, deep: true })

    provide('nodeTipoIdPai', tipoIdPai)

    async function getArvoresChatBotsDisponiveis() {
      try {
        const resArvoresChatBot = await ChatBotService.getArvoresDisponiveis(props.chatBotId)
        arvoresDisponiveis.value = resArvoresChatBot.filter(el => el.id !== props.arvoreId)
      } catch {
        arvoresDisponiveis.value = []
      }
    }

    const isNodeNovo = computed(() => nodeDataLocale.value.id === 0)

    const isNodeTipoTexto = computed(() => nodeDataLocale.value.chatBotNoTipoId === TipoNoChatBotEnum.Texto.id)
    const isNodeTipoFila = computed(() => nodeDataLocale.value.chatBotNoTipoId === TipoNoChatBotEnum.Fila.id)
    const isNodeTipoVoltar = computed(
      () => nodeDataLocale.value.chatBotNoTipoId === TipoNoChatBotEnum.Anterior.id || nodeDataLocale.value.chatBotNoTipoId === TipoNoChatBotEnum.Principal.id,
    )
    const isNodeTipoEncerrar = computed(() => nodeDataLocale.value.chatBotNoTipoId === TipoNoChatBotEnum.Encerrar.id)
    const isNodeTipoArvore = computed(() => nodeDataLocale.value.chatBotNoTipoId === TipoNoChatBotEnum.Arvore.id)
    const isNodeTipoBotao = computed(() => nodeDataLocale.value.chatBotNoTipoId === TipoNoChatBotEnum.Botao.id)
    const isNodeTipoLista = computed(() => nodeDataLocale.value.chatBotNoTipoId === TipoNoChatBotEnum.Lista.id)
    const isNodeTipoFormulario = computed(() => nodeDataLocale.value.chatBotNoTipoId === TipoNoChatBotEnum.Formulario.id)
    const isNodeTipoChatGPT = computed(() => nodeDataLocale.value.chatBotNoTipoId === TipoNoChatBotEnum.ChatGPT.id)
    const isNodeTipoNota = computed(() => nodeDataLocale.value.chatBotNoTipoId === TipoNoChatBotEnum.NotaPesquisa.id)
    const isNodeTipoAgendamento = computed(() => nodeDataLocale.value.chatBotNoTipoId === TipoNoChatBotEnum.Agendamento.id)
    const isNodeTipoAPI = computed(() => nodeDataLocale.value.chatBotNoTipoId === TipoNoChatBotEnum.API.id)

    const inativarSelecaoDeTipo = computed(() => (!isNodeNovo.value && isNodeTipoNota.value) || isNodePaiDoTipoNotaPesquisa.value)

    // const idPai = ref(7)
    const isIdPaiTipoBotaoOuLista = computed(
      () => tipoIdPai.value === TipoNoChatBotEnum.Botao.id || tipoIdPai.value === TipoNoChatBotEnum.Lista.id,
    )

    function nodeConfig() {
      emit('node-alterado')
    }

    // async function verArquivo() {
    //   const imagem = await axiosFlow.get(`chat-bots/${props.chatBotId}/arquivos/${nodeDataLocale.value.arquivoStorageId}`)
    // }

    watch(() => isNodeNovo, () => {
      getArvoresChatBotsDisponiveis()
      // verArquivo()
    }, { immediate: true, deep: true })

    const formTreeRef = ref(null)

    async function getRequestBody() {
      const tipoPai = tipoIdPai.value
      let data = {
        ...nodeDataLocale.value,
        tipoId: nodeDataLocale.value.chatBotNoTipoId,
      }

      if (data.tipoId === TipoNoChatBotEnum.Texto.id) {
        data = await NodeChatBotModel.tipoIdTexto(data, tipoPai)
      }

      if (data.tipoId === TipoNoChatBotEnum.Fila.id) {
        data = NodeChatBotModel.tipoIdFila(data, tipoPai)
      }

      if (data.tipoId === TipoNoChatBotEnum.Anterior || data.tipoId === TipoNoChatBotEnum.Principal.id) {
        data = NodeChatBotModel.tipoIdVoltar(data, tipoPai)
      }

      if (data.tipoId === TipoNoChatBotEnum.Encerrar.id) {
        data = NodeChatBotModel.tipoIdEncerrar(data, tipoPai)
      }

      if (data.tipoId === TipoNoChatBotEnum.Arvore.id) {
        data = NodeChatBotModel.tipoIdArvore(data, tipoPai)
      }

      if (data.tipoId === TipoNoChatBotEnum.Botao.id) {
        data = NodeChatBotModel.tipoIdBotao(data, tipoPai)
      }

      if (data.tipoId === TipoNoChatBotEnum.Lista.id) {
        data = NodeChatBotModel.tipoIdLista(data, tipoPai)
      }

      if (data.tipoId === TipoNoChatBotEnum.Formulario.id) {
        data = NodeChatBotModel.tipoIdFormulario(data, tipoPai)
      }

      if (data.tipoId === TipoNoChatBotEnum.ChatGPT.id) {
        data = NodeChatBotModel.tipoIdChatGPT(data, tipoPai)
      }

      if (data.tipoId === TipoNoChatBotEnum.NotaPesquisa.id) {
        data = NodeChatBotModel.tipoIdNotaPesquisa(data)
      }

      if (data.tipoId === TipoNoChatBotEnum.Agendamento.id) {
        data = NodeChatBotModel.tipoAgendamentoId(data, tipoPai)
      }

      if (data.tipoId === TipoNoChatBotEnum.API.id) {
        data = NodeChatBotModel.tipoIdApi(data, tipoPai)
      }

      return data
    }

    async function createNode() {
      loading.value = true
      try {
        if (isNodeTipoNota.value) {
          await ChatBotService.criarArvoreNoPesquisaNota(props.chatBotId, props.arvoreId, await getRequestBody())
        } else {
          await ChatBotService.criarArvoreNo(props.chatBotId, props.arvoreId, await getRequestBody())
        }
        emit('success-endpoint')
        loading.value = false
      } catch {
        loading.value = false
      }
    }

    async function updateNode() {
      const req = await getRequestBody()
      loading.value = true
      try {
        if (isNodeTipoNota.value) {
          await ChatBotService.atualizarArvoreNoPesquisaNota(props.chatBotId, props.arvoreId, req.id, req)
        } else {
          await ChatBotService.atualizarArvoreNo(props.chatBotId, props.arvoreId, req.id, req)
        }
        emit('success-endpoint')
        loading.value = false
      } catch {
        loading.value = false
      }
    }

    async function handleSubmit() {
      if (loading.value) return
      if (formTreeRef.value.validate()) {
        if (isNodeNovo.value) {
          createNode()
        } else {
          updateNode()
        }
      } else {
        Vue.$toast.warning('Preencha corretamente os campos antes de salvar')
      }
    }

    return {
      loading,
      tiposDeNo,
      formTreeRef,
      nodeDataLocale,
      arvoresDisponiveis,
      isNodePaiDoTipoNotaPesquisa,

      isNodeTipoTexto,
      isNodeTipoFila,
      isNodeTipoVoltar,
      isNodeTipoEncerrar,
      isNodeTipoArvore,
      isNodeTipoBotao,
      isNodeTipoLista,
      isNodeTipoFormulario,
      isNodeTipoChatGPT,
      isNodeTipoNota,
      isNodeTipoAgendamento,
      isNodeTipoAPI,

      inativarSelecaoDeTipo,

      isIdPaiTipoBotaoOuLista,
      nodeConfig,
      handleSubmit,
      validators: {
        required,
        select,
      },
    }
  },

}
</script>
